module.exports = __webpack_public_path__ + "img/product1.cec21161.jpg";